import {
  Radio,
  Card,
  Divider,
  Input,
  InputNumber,
  Select,
  DatePicker,
  Button,
  Modal,
  notification,
  // message,
  Form,
  Spin,
  // Switch,
} from "antd";
import { useEffect, useState } from "react";
import moment from "moment";
import { format } from "../App";
import "./sellPac.css";
import MenuBar from "./menu/MenuBar";
import { useSelector, } from "react-redux";
// import { delUser, setUser } from "../app/features/user/userSlice";
import { pad } from "../data/allfunction";
// import { useHistory } from "react-router-dom";
// import { db } from "../data/firebase";
// import MakeDocSafty from "./pdf/MakeDocSafty";
import { changLgValue, getDataPost_2, getPDF_2 } from "../data/allfunction_2";
import { FromFineOldPolicy, fromTypeCar } from "./SellThirt_2";
const ip = process.env.REACT_APP_IP;

const { Option } = Select;
const dateFormat = "DD-MM-YYYY";
// const dateFormat_2 = "DD-MM-YYYY HH:mm:ss";
// const dateFormat = 'YYYY-MM-DD HH:mm:ss'

function Sellpac_2() {
  // const dispatch = useDispatch();
  // const history = useHistory();
  const [form] = Form.useForm();
  const { token, retoken, agent_Code,
    // user,
    user_id, agent_scp_p } = useSelector(
      (state) => {
        return state.user;
      }
    );
  const { value } = useSelector((state) => state.lg);
  const [modalsave, setmodalsave] = useState(false);
  const [listData, setlistData] = useState([]);
  // -----------------
  const [o_name, seto_name] = useState("");
  const [o_tel, seto_tel] = useState("");
  const [o_type, seto_type] = useState("");
  const [o_make, seto_make] = useState("");
  const [o_plate, seto_plate] = useState("");
  const [o_color, seto_color] = useState("");
  const [o_power, seto_power] = useState("");
  const [o_engine, seto_engine] = useState("");
  const [o_chassis, seto_chassis] = useState("");
  const [o_weight, seto_weight] = useState(0);
  const [o_seats, seto_seats] = useState(0);
  const [a_type_power, set_a_type_power] = useState(0);
  const [o_address, seto_address] = useState("");

  const [a_used, seta_used] = useState("private");
  const [a_type, seta_type] = useState("new");

  const [data, setdata] = useState([]);
  const [data_group, setdata_group] = useState([]);
  const [premuim, setpremuim] = useState("");
  const [vat, setvat] = useState(0);
  const [register, setregister] = useState("");
  const [total_premuim, settotal_premuim] = useState("");

  const [startCover, setstartCover] = useState();
  const [endCover, setendCover] = useState();
  const [sent_startCover, setsent_startCover] = useState();
  const [sent_endCover, setsent_endCover] = useState();

  const [cover, setcover] = useState("");

  const [emp_paid, setemp_paid] = useState(0);
  // const [modalShowPolicy, setmodalShowPolicy] = useState(false);
  // const [no, setno] = useState(0);
  // const [datasentPDF, setdatasentPDF] = useState(0);

  const [provice, setprovice] = useState([]);
  const [dist, setdist] = useState([]);
  const [proviceSelect, setproviceSelect] = useState("");
  const [proviceid, setproviceid] = useState(null);
  const [distSelect, setdistSelect] = useState("");
  const [villageSelect, setvillageSelect] = useState("");

  const [loadingPDF, setloadingPDF] = useState(false);
  const [package_id, setpackage_id] = useState(null);

  const [pack_type_commit, setpack_type_commit] = useState("");

  const [stateButtonSave, setstateButtonSave] = useState(true);

  // --------------------
  function retset_value_premuim() {
    setcover("");
    setpackage_id(null);
    settotal_premuim(0);
    setregister(0);
    setvat(0);
    setpremuim(0);
    setpack_type_commit("");
  }

  function onChange_Car(value) {
    try {
      let d = JSON.parse(value);
      //console.log(d);
      setcover(d.pack_name);
      setpackage_id(d.pack_id);
      settotal_premuim(d.pack_prmium);
      setregister(d.pack_registration);
      setvat(d.pack_tex);
      setpremuim(d.pack_first_premium);
      setpack_type_commit(d.pack_type_commit);
    } catch (error) {
      retset_value_premuim()
    }
  }
  function onChange_timestart(value, dateString) {
    setstartCover(moment(value).format(dateFormat));
    setsent_startCover(value);

    setendCover(moment(value).add(1, "Y").subtract(1, "d").format(dateFormat));
    // console.log(moment(value).add(1, 'Y').subtract(1, 'd').format(dateFormat))
    setsent_endCover(moment(value).add(1, "Y").subtract(1, "d"));
  }

  // function onChange_timeend(value, dateString) {
  //   setendCover(moment(value).format(dateFormat));
  //   setsent_endCover(value);
  // }

  // const onReset = () => {
  //   form.resetFields();
  // };
  const submitForm = (e) => {
    seto_name(e.name === undefined ? "" : e.name);
    setvillageSelect(e.addressVill === undefined ? "" : e.addressVill);
    setdistSelect(e.addressDist === undefined ? "" : e.addressDist);
    setproviceSelect(e.addressPro === undefined ? "" : e.addressPro);
    seto_tel(e.phone === undefined ? "" : e.phone);
    seto_type(e.typeCar === undefined ? "" : e.typeCar);
    seto_make(e.make === undefined ? "" : e.make);
    seto_plate(e.plate === undefined ? "" : e.plate);
    seto_color(e.color === undefined ? "" : e.color);
    seto_power(e.power === undefined ? "" : e.power);
    // seto_engine(e.engine === undefined ? "" : e.engine);
    // seto_chassis(e.chassis === undefined ? "" : e.chassis);
    seto_weight(e.weight === undefined ? "" : e.weight);
    seto_seats(e.seats === undefined ? "" : e.seats);

    // setsent_startCover(moment(e.start).format('YYYY-MM-DD HH:mm:ss'))
    // setsent_endCover(moment(e.end).format('YYYY-MM-DD HH:mm:ss'))

    // setsent_startCover(moment(e.start).format('YYYY-MM-DD HH:mm:ss'))
    // setsent_endCover(moment(e.end).format('YYYY-MM-DD HH:mm:ss'))

    setmodalsave(true);
  };
  async function createPolicy() {
    setloadingPDF(true);
    setstateButtonSave(false);
    const dataSetForGet = {
      o_name: o_name,
      // o_address: `${villageSelect} ເມືອງ ${distSelect} ແຂວງ ${proviceSelect}`,
      o_address: o_address,
      o_tel: o_tel,
      o_type: o_type,
      o_make: o_make,
      o_plate: o_plate,
      o_color: o_color,
      o_power: o_power,
      o_engine: o_engine,
      o_chassis: o_chassis,
      o_weight: o_weight,
      o_seats: o_seats,
      a_used: a_used,
      a_type: a_type,
      premuim: premuim,
      vat: vat,
      register: register,
      total_premuim: total_premuim,
      start: moment(sent_startCover).format("YYYY-MM-DD"),
      end: moment(sent_endCover).format("YYYY-MM-DD"),
      cover: cover,
      user_add: user_id,
      dateadd: Date.now(),
      emp_paid,
      package_id,
      thediductible: null,
      emp_add: null,
      pack_type_commit,
      a_type_power,
      oldPolicyNo
    };
    // console.log(dataSetForGet);

    let l = ip + "sell_2_online/insert_pack";
    let addpolicy = await getDataPost_2(l, dataSetForGet, token, retoken);
    // console.log(addpolicy);

    //   {
    //     "fieldCount": 0,
    //     "affectedRows": 1,
    //     "insertId": 1007,
    //     "info": "",
    //     "serverStatus": 2,
    //     "warningStatus": 0
    // }

    if (addpolicy.affectedRows === 1) {
      notification["success"]({
        message: "ແຈ້ງເຕືອນ",
        description:
          "ສ້າງສັນຍາປະກັນໄພອອນລາຍ ເລກທີ: " +
          pad(addpolicy.insertId) +
          " ສຳເຫຼັ້ດ ກະລຸນາກວດສອບໂຟເດີ້ ດາວໂລດ",
      });
      setmodalsave(false);
      get_pdf_policy(addpolicy.insertId);
      setTimeout(() => {
        setloadingPDF(false);
        window.location.reload();
        notification.destroy();
      }, 6000);
    } else {
      setloadingPDF(false);
      setmodalsave(false);
    }
    setTimeout(() => {
      setstateButtonSave(true);
    }, 3000);
  }
  async function get_pdf_policy(no) {
    let l = ip + "sell_2_online/pdf_log";
    let dataSetForGet = { no };
    let pro = await getPDF_2(l, dataSetForGet, token, retoken);

    // Create a temporary URL representing the Blob
    const url = window.URL.createObjectURL(pro);

    // Create a link element
    const a = document.createElement("a");
    a.href = url;
    a.download = pad(no);

    // Append the link to the body
    document.body.appendChild(a);

    // Trigger a click event on the link to initiate download
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  //ດຶງແຂວງທັງໝົ້ດ
  useEffect(() => {
    getData();
    async function getData() {
      let l = ip + "sell_2_online/provice";
      let dataSetForGet = {};
      let pro = await getDataPost_2(l, dataSetForGet, token, retoken);
      //  console.log(pro);
      if (pro?.length > 0) {
        setprovice(pro);
      } else {
        setprovice([]);
      }
    }
  }, [token, retoken]);
  //ລາຍຊື່ເມືອງຕາມແຂວງ
  useEffect(() => {
    setdist([]);
    getData();
    async function getData() {
      if (proviceid != null) {
        let l = ip + "sell_2_online/distic";
        let dataSetForGet = { dist_provice: proviceid };
        let dis = await getDataPost_2(l, dataSetForGet, token, retoken);
        //   console.log(dis);
        if (dis?.length > 0) {
          setdist(dis);
        } else {
          setdist([]);
        }
      }
    }
  }, [proviceid, token, retoken]);

  //ດຶງແພັກແກັດ
  useEffect(() => {
    getData();
    async function getData() {
      try {
        let l = ip + "sell_2_online/sell_2_packges";
        let dataSetForGet = {};
        let pack = await getDataPost_2(l, dataSetForGet, token, retoken);
        // console.log(pack);
        if (pack?.length > 0) {
          //ແຍກ  ແພັກແກັດໂຕເກົ່າອອກ
          let filteredArray = pack.filter(
            (item) => new Date(item.pack_create) >= new Date("2024-04-25")
          );

          //  console.log(agent_scp_p);
          //ປ່ຽນຄ່າຈາກຖານຂໍ້ມູນມາເປັນ ອາເລ
          let aArray;
          if (
            (agent_scp_p === null) |
            (agent_scp_p === " ") |
            (agent_scp_p === undefined)
          ) {
            //ໃດ້ອາເລທີ່ບໍ່ມີລະຫັດແພັກແກັດ
            aArray = [];
          } else {
            //ນຳເອົາຂໍ້ມູນລະຫັດແພັກແກັດມາແບ່ງເປັນອາເລ
            aArray = agent_scp_p?.split(",");
          }

          // ແຍກວ່າ ຕົວແທນໃດມີແພັກແກັດພິເສດ
          let resultArray = filteredArray.filter((item) => {
            if (item.pack_spc === 1) {
              // ຖ້າເປັນແພັກແກັດພິເສດແມ່ນ 1
              // ເອົາມາກວດສອບວ່າ ຄ່າທີ່ຢູ່ໃນ  aArray ໂຕໃດເທົ່າກັບ pack_id ໃຫ້ສົ່ງອອກມາ
              return aArray.includes(item.pack_id.toString());
            } else {
              //  ຖ້າເປັນແພັກແກັດພິເສດແມ່ນ 0 ຈັດກັບອອບແຈັກໃວ້ໃນອາເລ
              return true;
            }
          });
          // console.log(resultArray);
          // setdata(resultArray);

          const groupedData = Object.entries(
            resultArray.reduce((acc, item) => {
              if (!acc[item.pack_vel_1]) {
                acc[item.pack_vel_1] = [];
              }
              acc[item.pack_vel_1].push(item);
              return acc;
            }, {})
          ).map(([key, value]) => ({ label: key, value: value }));
           console.log(groupedData);
          setdata_group(groupedData)

        } else {
          throw new Error();
        }
      } catch (error) {
        console.log(error);
        setdata_group([])
      }
    }
  }, [token, retoken]);





  //ດຶງປະເພດລົດທັງໝົ້ດ
  useEffect(async () => {
    let l = ip + "sell_2_online/car_type";
    let dataSetForGet = {};
    let pro = await getDataPost_2(l, dataSetForGet, token, retoken);
    //  console.log(pro);
    if (pro?.length > 0) {
      setlistData(pro);
    } else {
      setlistData([]);
    }
  }, [token, retoken]);

  const [oldPolicyNo, set_oldPolicyNo] = useState(null);
  const [oldPolicy, set_oldPolicy] = useState([]);
  useEffect(() => {
    if (a_type == "renew") {
      Modal.info({
        title: ` ${changLgValue(value, 94)}`,
        content: (
          <FromFineOldPolicy
            agent_Code={agent_Code}
            token={token}
            retoken={retoken}
            set_oldPolicy={set_oldPolicy}
            value={value}
          />

        ),
        okText: ` ${changLgValue(value, 106)}`, // ປິດໜ້າຕ່າງ
        onOk() {
          console.log('OK clicked');
        },
        width: 700
      });
    } else {
      set_oldPolicyNo(null)
    }
    console.log(a_type)
    set_oldPolicy([])
  }, [a_type])

  useEffect(() => {
    console.log(oldPolicy)
    if (oldPolicy.length > 0) {


      form.setFieldsValue({ name: oldPolicy[0]?.o_name || "" });
      seto_address(oldPolicy[0]?.o_address || "")
      form.setFieldsValue({ phone: oldPolicy[0]?.o_tel || "" });
      form.setFieldsValue({ make: oldPolicy[0]?.o_make || "" });
      form.setFieldsValue({ plate: oldPolicy[0]?.o_plate || "" });
      form.setFieldsValue({ color: oldPolicy[0]?.o_color || "" });
      form.setFieldsValue({ power: oldPolicy[0]?.o_power || "" });

      // form.setFieldsValue({ engine: oldPolicy[0]?.o_engine || "" });
      // form.setFieldsValue({ chassis: oldPolicy[0]?.o_chassis || "" });
      seto_engine(oldPolicy[0]?.o_engine || "");
      seto_chassis(oldPolicy[0]?.o_chassis || "");

      form.setFieldsValue({ weight: oldPolicy[0]?.o_weight || "" });
      form.setFieldsValue({ seats: oldPolicy[0]?.o_seats || "" });
      set_oldPolicyNo(`${oldPolicy[0]?.type == "ONLINE" ? "E-" : " "} ${oldPolicy[0]?.policy_concat_no}` || null)


    }

  }, [oldPolicy])
  useEffect(() => {

    if (proviceSelect === '') {
      seto_address(``)
    } else {
      seto_address(`${villageSelect} ເມືອງ ${distSelect} ແຂວງ ${proviceSelect}`)
    }
  }, [villageSelect, distSelect, proviceSelect])

  return (
    <>
      <MenuBar />
      {loadingPDF ? <Spinshow /> : Datashow()}
      <Modal
        title="ກວດຂໍ້ມູນໃຫ້ລະອຽດກ່ອນການບັນທືກ"
        visible={modalsave}
        closable={false}
        footer={[
          <Button key="ກັບຄືນ" onClick={() => setmodalsave(false)}>
            ກັບຄືນ
          </Button>,
          <Button
            key="ຕົກລົງ"
            onClick={() => {
              if (stateButtonSave) {
                createPolicy();
              } else {
                alert("ກະລຸນາລໍ ຖ້າທ່ານໃດ້ກົດບັນທຶກຂໍ້ມູນແລ້ວ");
              }
            }}
          >
            ຕົກລົງ
          </Button>,
        ]}
      >
        <div className="B">
          <div className="B1"> {/* ຜູ້ໃດ້ຮັບການປະກັນໄພ  */}
            {changLgValue(value, 7)} </div>
          <div className="B2">{o_name}</div>
        </div>
        <div className="B">
          <div className="B1">  {/* ເລກທະບຽນ */}
            {changLgValue(value, 13)} </div>
          <div className="B2">{o_plate}</div>
        </div>
        <div className="B">
          <div className="B1"> {/* ເລກຈັກ */}
            {changLgValue(value, 16)} </div>
          <div className="B2">{o_engine}</div>
        </div>
        <div className="B">
          <div className="B1">    {/* ເລກຖັງ  */}
            {changLgValue(value, 17)} </div>
          <div className="B2">{o_chassis}</div>
        </div>
        <div className="B">
          <div className="B1"> {/* ການຄຸ້ມກັນ  */}
            {changLgValue(value, 86)} </div>
          <div className="B2">{cover}</div>
        </div>
        <div className="B">
          <div className="B1"> {/* ວັນທີເລີ່ມຄຸ້ມກັນ  */}
            {changLgValue(value, 76)} </div>
          <div className="B2">{startCover}</div>
        </div>
        <div className="B">
          <div className="B1">    {/* ວັນທີສຶ້ນສຸດຄຸ້ມກັນ  */}
            {changLgValue(value, 77)} </div>
          <div className="B2">{endCover}</div>
        </div>
        <div className="B">
          <div className="B1">    {/* ລວມມູນຄ່າຕ້ອງຈ່າຍ  */}
            {changLgValue(value, 85)} </div>
          <div className="B2">{format(total_premuim)}</div>
        </div>
        <div className="B">
          <div className="B1">  {/* ສະຖານະການຊຳລະ */}
            {changLgValue(value, 57)} </div>
          <div className="B2">
            {" "}
            {emp_paid === 1 ?
              //  "ຊຳລະສົມບູນ"
              changLgValue(value, 57)
              :
              // "ລໍຖ້າການຊຳລະ"
              changLgValue(value, 56)
            }
          </div>
        </div>
      </Modal>
    </>
  );

  function Datashow() {
    return (
      <div className="container">
        {/* {JSON.stringify(agent_scp_p)} */}
        <Form
          form={form}
          name="sellpac"
          // labelCol={{ span: 8 }}
          // wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={submitForm}
          autoComplete="off"
        >
          <Card className="C">
            <Divider orientation="left" plain>
              {/* ຂໍ້ມູນຂອງຜູ້ໄດ້ຮັບການປະກັນໄພ_2 */}
              {changLgValue(value, 6)} v2
            </Divider>
            <Form.Item
              className="mb-0"
              // label="ຊື່ ແລະ ນາມສະກຸນ"
              name="name"
            >
              <Input
                className="TI"
                // placeholder="ຊື່ ແລະ ນາມສະກຸນ"
                placeholder={changLgValue(value, 7)}
                onChange={(e) => {
                  //  seto_name(e.target.value)
                }}
              />
            </Form.Item>

            <div className="row row-cols-1 row-cols-md-3">
              <div className="col">
                <Form.Item
                  className="mb-0"
                  // label="ທີ່ຢູ່ແຂວງ"
                  name="addressPro"
                >
                  <Select
                    // placeholder="ເລືອກແຂວງ"
                    placeholder={changLgValue(value, 8)}
                    optionFilterProp="children"
                    onChange={(p) => {
                      let provice_id = provice.find(
                        (e) => e.provice_name === p
                      );
                      setproviceid(provice_id.provice_id);
                      setproviceSelect(p);
                      // console.log(p, provice_id.provice_id)
                    }}
                    className="TI"
                    style={{ width: "100%" }}
                  >
                    {provice.map((v) => {
                      return (
                        <Option key={v.provice_id} value={v.provice_name}>
                          {v.provice_name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </div>
              <div className="col">
                <Form.Item
                  className="mb-0"
                  // label="ທີ່ຢູ່ເມືອງ"
                  name="addressDist"
                >
                  <Select
                    // placeholder="ເລືອກເມືອງ"
                    placeholder={changLgValue(value, 9)}
                    optionFilterProp="children"
                    onChange={(e) => {
                      setdistSelect(e);
                    }}
                    className="TI"
                    style={{ width: "100%" }}
                  >
                    {dist.map((v) => {
                      return (
                        <Option key={v.dist_id} value={v.dist_name}>
                          {v.dist_name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </div>
              <div className="col">
                <Form.Item
                  className="mb-0"
                  // label="ພິມຊື່ບ້ານ"
                  name="addressVill"

                >
                  <Input
                    className="TI"
                    // placeholder="ພິມຊື່ບ້ານ"
                    placeholder={changLgValue(value, 10)}
                  onChange={v => { setvillageSelect(v.target.value) }}
                  />
                </Form.Item>
              </div>
            </div>
            {o_address === '' ? null : <p style={{ color: 'red' }}> {o_address}</p>}





            <Form.Item
              className="mb-0"
              // label="ໂທລະສັບ"
              name="phone"
            >
              <Input
                className="TI"
                // placeholder="ໂທລະສັບ"
                placeholder={changLgValue(value, 11)}
              // onChange={(e) => { seto_tel(e.target.value) }}
              />
            </Form.Item>
            <Form.Item
              className="mb-0"
              // label="ປະເພດລົດ"
              name="typeCar"
              rules={[{ required: true, message: "ກະລຸນາເລືອກປະເພດລົດ" }]}
            >
              <Select
                // placeholder="ປະເພດລົດ"
                placeholder={changLgValue(value, 89)}
                optionFilterProp="children"
                onChange={(e) => {
                  seto_type(e);
                }}
                className="TI"
                style={{ width: "100%" }}
              >
                {listData.map((v, i) => {
                  return v.car_type_ml === 1 ? (
                    <Option key={i} value={v.car_type_name_la}>
                      {/* {v.car_type_name_la} */}
                      {value == 1 ? v.car_type_name_la : v.car_type_name_ch}
                    </Option>
                  ) : null;
                })}
              </Select>
            </Form.Item>
            <Form.Item
              className="mb-0"
              // label="ຫຍີ່ຫໍ້"
              name="make"
            >
              <Input
                className="TI"
                // placeholder="ຫຍີ່ຫໍ້"
                placeholder={changLgValue(value, 12)}
              // onChange={(e) => { seto_make(e.target.value) }}
              />
            </Form.Item>
            <Form.Item
              className="mb-0"
              // label="ເລກທະບຽນ"
              name="plate"
            >
              <Input
                className="TI"
                // placeholder="ເລກທະບຽນ"
                placeholder={changLgValue(value, 13)}
              // onChange={(e) => {                  seto_plate(e.target.value)                }}
              />
            </Form.Item>
            <Form.Item
              className="mb-0"
              // label="ສີລົດ"
              name="color"
            >
              <Input
                className="TI"
                // placeholder="ສີລົດ"
                placeholder={changLgValue(value, 14)}
              // onChange={(e) => { seto_color(e.target.value) }}
              />
            </Form.Item>
            <Form.Item
              className="mb-0"
              // label="ຄວາມແຮງເປັນ ເຊເຊ"
              name="power"
            >
              <Input
                className="TI"
                // placeholder="ຄວາມແຮງເປັນ ເຊເຊ"
                placeholder={changLgValue(value, 15)}
              // onChange={(e) => {                  seto_power(e.target.value)                }}
              />
            </Form.Item>
            <Form.Item
              className="mb-0"
              // label="ເລກຈັກ"
            //  name="engine"
            >
              <Input
                className="TI"
                // placeholder="ເລກຈັກ"
                placeholder={changLgValue(value, 16)}
                onChange={(e) => {
                  seto_engine(e.target.value.toUpperCase());
                  // console.log(e.target.value.toUpperCase())
                }}
                value={o_engine}
              />
            </Form.Item>
            <Form.Item
              className="mb-0"
              // label="ເລກຖັງ"
              // name="chassis"
            >
              <Input
                className="TI"
                // placeholder="ເລກຖັງ"
                placeholder={changLgValue(value, 17)}
                onChange={(e) => {
                  seto_chassis(e.target.value.toUpperCase());
                }}
                value={o_chassis}
              />
            </Form.Item>
            <Form.Item
              className="mb-0"
              // label="ນ້ຳໜັກຄິດໄລ່ເປັນໂຕນ"
              name="weight"
            >
              <InputNumber
                className="TIN"
                min={0}
                // placeholder="ນ້ຳໜັກຄິດໄລ່ເປັນໂຕນ"
                placeholder={changLgValue(value, 18)}
                max={60}
              //   onChange={(e) => { seto_weight(e) }}
              />
            </Form.Item>
            <Form.Item
              className="mb-0"
              // label="ຈຳນວນບ່ອນນັ່ງ"
              name="seats"
              rules={[{ required: true, message: "ກະລຸນາເພີ່ມຈຳນວນບ່ອນນັ່ງ" }]}
            >
              <InputNumber
                className="TIN"
                min={2}
                max={50}
                // placeholder="ຈຳນວນບ່ອນນັ່ງ"
                placeholder={changLgValue(value, 19)}
              //   onChange={(e) => { seto_seats(e) }}
              />
            </Form.Item>
            {fromTypeCar(a_type_power, set_a_type_power, value)}
          </Card>
          <Card className="C">
            <Divider orientation="left" plain>
              {/* ເລືອກປະເພດແພັກແກັດ */}
              {changLgValue(value, 65)}
            </Divider>

            <Radio.Group
              // value={value}
              onChange={v => {
                form.resetFields(["package"])
                retset_value_premuim()
                try {
                  // console.log(v.target.value)
                  if (data.length < 0) {
                    throw new Error('ກະລຸນາກວດສອບແພັກແກັດ')
                  } else {
                    setdata(v.target.value)
                  }
                } catch (error) {
                  console.log(error)
                  setdata([])
                }
              }}
              options={data_group} 
            />

            

            <Form.Item
              className="mb-0 mt-3"
              // label="ກະລຸນາເລືອກທາງເລືອກ"
              name="package"
              rules={[
                { required: true, message: "ກະລຸນາເລືອກແພັກເກັດເສຍກ່ອນ" },
              ]}
            >
              <Select
                // placeholder="ທາງເລືອກການຄຸ້ມກັນ"
                placeholder={changLgValue(value, 88)}
                optionFilterProp="children"
                onChange={onChange_Car}
                className="SCP"
              >
                {data.map((e, i) => {
                  // ຖ້າ ເປັນຕົວແທນທຳມະດາຈະສົ່ງແຕ່ແພັກແກັດທຳມະດາອອກ ຖ້າຕົວແທນມີແພັກແກັດພິເສດຈະສົ່ງແຕ່ແພັກແກັດພິເສດອອກ ແລະ ສະເພາະຂອງຕົວແທນ ນັ້ນໆ
                  // ເປັນແພັກແກັດພິເສດຫຼືບໍ່
                  if (e.pack_spc == 0) {
                    //ບໍ່ເປັນສັນຍາພິເສດ
                    if (
                      agent_scp_p == "" ||
                      agent_scp_p == null ||
                      agent_scp_p == undefined
                    ) {
                      // ກວດສອບວ່າ ທ່ານບໍ່ໃດ້ມີລິດສັນຍາພິເສດ
                      //ຖ້າບໍ່ມີໃຫ້ສົ່ງແພັກແກັດທຳມະດາອອກໄປ
                      return (
                        <Option key={i} value={JSON.stringify(e)}>
                          {e.pack_name}
                        </Option>
                      );
                    } else {
                      //ຖ້າມີບໍ່ສົ່ງ
                      return;
                    }
                  } else {
                    //ເປັນສັນຍາພິເສດ
                    if (isValueInList(agent_scp_p, e?.pack_id)) {
                      //ກວດສອບວ່າແມ່ນແພັກແກັດທ່ານຫຼືບໍ່ ຖ້າມີໃຫ້ສົ່ງອອກໄປ
                      return (
                        <Option key={i} value={JSON.stringify(e)}>
                          {e.pack_name}
                        </Option>
                      );
                    }
                  }
                })}
              </Select>
            </Form.Item>
          </Card>
          <Card className="C">
            <Divider orientation="left" plain>
              {/* ປະເພດຂອງສັນຍາປະກັນໄພ */}
              {changLgValue(value, 23)}
            </Divider>
            {/* ພາກທີ 1: ການປະກັນໄພ ທາງແພ່ງຕໍ່ບຸກຄົນທີສາມ */}
            {changLgValue(value, 24)}
            <Radio.Group
              onChange={(e) => seta_used(e.target.value)}
              value={a_used}
              className="R"
            >
              <Radio value={"private"}>
                {/* ລົດສ່ວນຕົວ */}
                {changLgValue(value, 25)}
              </Radio>
              <Radio value={"business"}>
                {/* ຮັບຈ້າງ */}
                {changLgValue(value, 26)}
              </Radio>
            </Radio.Group>
            <Radio.Group
              onChange={(e) => seta_type(e.target.value)}
              value={a_type}
              className="R"
            >
              <Radio value={"new"}>
                {/* ສັນຍາໃໝ່ */}
                {changLgValue(value, 27)}
              </Radio>
              <Radio value={"renew"}>
                {/* ຕໍ່ສັນຍາ */}
                {changLgValue(value, 28)}  {oldPolicy.length > 0 && `/ ${changLgValue(value, 95)}: ${oldPolicy[0]?.type} : ${changLgValue(value, 98)} : ${oldPolicy[0]?.policy_concat_no}`}

              </Radio>
            </Radio.Group>
          </Card>
          <Card className="C">
            <Divider orientation="left" plain>
              {/* ຄິດໄລຄ່າທຳນຽມ */}
              {changLgValue(value, 49)}
            </Divider>
            <div className="B">
              <div className="B1">  {/* ຄ່າທຳນຽມຕົວຈິງບໍ່ທັນລວມອາກອນ  */}
                {changLgValue(value, 50)} </div>
              <div className="B2">{format(premuim)}</div>
            </div>
            <div className="B">
              <div className="B1">  {/* ອາກອນມູນຄ່າເພີ່ມ */}
                {changLgValue(value, 51)} </div>
              <div className="B2">{format(vat)}</div>
            </div>
            <div className="B">
              <div className="B1">  {/* ຄ່າຂື້ນທະບຽນ  */}
                {changLgValue(value, 52)} </div>
              <div className="B2">{format(register)}</div>
            </div>
            <div className="B">
              <div className="B1">  {/* ລວມມູນຄ່າຕ້ອງຈ່າຍ */}
                {changLgValue(value, 53)} </div>
              <div className="B2">{format(total_premuim)}</div>
            </div>
          </Card>
          <Card className="C">
            <Divider orientation="left" plain>
              {/* ການຊຳລະເງິນ */}
              {changLgValue(value, 54)}
            </Divider>
            <div className="BDP">
              <div className="B1DP"> {/* ສະຖານະການຊຳລະ */}
                {changLgValue(value, 55)}</div>
              <div className="B2DP">
                <Radio.Group
                  onChange={(e) => {
                    setemp_paid(e.target.value);
                  }}
                  value={emp_paid}
                >
                  <Radio value={0}> {/* ລໍຖ້າການຊຳລະ */}
                    {changLgValue(value, 56)}</Radio>
                  <Radio value={1}>  {/* ຊຳລະສົມບູນ */}
                    {changLgValue(value, 57)}</Radio>
                </Radio.Group>
              </div>
            </div>
          </Card>
          <br />
          {/* *ເພີ່ມວັນສິ້ນສຸດດ້ວຍຕົນເອງ{" "}
          <span style={{ color: "red" }}>
            {" "}
            (ຖ້າປິດສັນຍາຈະຄຸ້ມກັນເປັນເວລາ 1 ປີ){" "}
          </span>
          <Switch
            checked={addEnd}
            checkedChildren="ປິດ"
            unCheckedChildren="ເປີດ"
            onChange={(e) => {
              setAddEnd(e);
              form.setFieldsValue({ start: "" });
              form.setFieldsValue({ end: "" });
            }}
          /> */}
          <div className="BDP mt-2">
            <div className="B1DP">
              <Form.Item
                // label="ວັນທີເລີ່ມຄຸ້ມກັນ ::"
                label={changLgValue(value, 58)}
                name="start"
                rules={[
                  {
                    required: true,
                    message: "ກະລຸນາເລືອກ ວັນທີເລີ່ມຄຸ້ມກັນ ເສຍກ່ອນ",
                  },
                ]}
              >
                <DatePicker
                  // placeholder="ວັນທີເລີ່ມຄຸ້ມກັນ"
                  placeholder={changLgValue(value, 59)}
                  className="DP"
                  // showTime
                  onChange={onChange_timestart}
                  format={dateFormat}
                  disabledDate={(current) =>
                    current.isBefore(moment().subtract(1, "day"))
                  }
                />
              </Form.Item>
            </div>
            {/* {addEnd && (
              <div className="B2DP">
                <Form.Item
                  label=" ວັນທີສຶ້ນສຸດຄຸ້ມກັນ::"
                  name="end"
                  rules={[
                    {
                      required: true,
                      message: "ກະລຸນາເລືອກ  ວັນທີສຶ້ນສຸດຄຸ້ມກັນ ເສຍກ່ອນ",
                    },
                  ]}
                >
                  <DatePicker
                    placeholder="ວັນທີສຶ້ນສຸດຄຸ້ມກັນ"
                    className="DP"
                    showTime
                    onChange={onChange_timeend}
                    format={dateFormat}
                  />
                </Form.Item>
              </div>
            )} */}
            {/* <div className='B2DP'>
              <Form.Item

                label=" ວັນທີສຶ້ນສຸດຄຸ້ມກັນ::"
                name="end"
                rules={[{ required: true, message: 'ກະລຸນາເລືອກ  ວັນທີສຶ້ນສຸດຄຸ້ມກັນ ເສຍກ່ອນ' }]}
              >
                <DatePicker
                  placeholder='ວັນທີສຶ້ນສຸດຄຸ້ມກັນ'
                  className='DP'
                  showTime onChange={onChange_timeend}
                  format={dateFormat}
                />
              </Form.Item>
            </div> */}
          </div>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
              {/* ບັນທຶກຂໍ້ມູນ */}
              {changLgValue(value, 60)}
            </Button>
          </Form.Item>
        </Form>

        <br />
        <br />
      </div>
    );
  }
}

export function Spinshow() {
  return (
    <div className="fullscreenDiv">
      <div className="center">
        <Spin tip="ກະລຸນາລໍຖ້າ..." />
      </div>
    </div>
  );
}

export default Sellpac_2;

function isValueInList(a, b) {
  try {
    // แปลง a เป็นอาร์เรย์โดยใช้ split
    const list = a.split(",").map(Number); // แปลงค่าในอาร์เรย์เป็นตัวเลข
    return list.includes(b); // ตรวจสอบว่าค่า b มีอยู่ใน list หรือไม่
  } catch (error) {
    return false;
  }
}
